import React, { useCallback, useState } from "react";
import { useHistory } from "react-router-dom";
import { getHomePaymentsInfolist } from "../../api/BorrowerApi";
import { getMockHomePaymentsInfolist } from "../../api/mock/MockBorrowerApi";
import { convertToDollar, formatDataProperties, handleErrorResponse } from "../../Helpers";
import { IHomePaymentsObj, IHomePaymentsView } from "../interfaces/Borrower";
import "../../styles/borrower/home.scss";
import { IErrorResponse, IProxyUser } from "../interfaces/Global";
import BWHomeViewAllFrame from "./BWHomeViewAllFrame";
import { FeatureFlags } from "../constants/LocalServerConstants";

interface IBWHomePayments {
  isGreaterThanMobile: boolean;
  isGreaterThanTablet: boolean;
  isSidebar: boolean;
  isMessage: boolean;
  setIsMessage: (value: boolean) => React.Dispatch<React.SetStateAction<boolean>>;
  errorResponse: IErrorResponse | undefined; 
  setErrorResponse: (value: boolean) => React.Dispatch<React.SetStateAction<IErrorResponse | undefined>> 
  proxyUser: IProxyUser | undefined;
}

const BWHomePayments = ({...props} : IBWHomePayments) => {
  const [isLoading, setIsLoading] = useState(true as boolean);
  const [homePaymentsInfoData, setHomePaymentsInfoData] = useState([] as IHomePaymentsObj[]);
  
  const history = useHistory();
  const handleError = useCallback(() => {
    history.push("/error");
  }, [history]);

  const convertToTableFormat = (payments) => {
    const paymentsTable = [] as IHomePaymentsView[];
    payments.forEach(payment => paymentsTable.push({
      "loanNumber": payment.loanNumber,
      "project": payment.projectName,
      "amount": convertToDollar(payment.transactionAmount),
      "date": new Date(payment.transactionEffectiveDate).toLocaleDateString(),
      "status": payment.isActive ? "Active" : "InActive"
    }));

    const orderdPaymentsTable = paymentsTable.sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime());
    return formatDataProperties(orderdPaymentsTable, [{field: "loanNumber", action: "rename", name: "Loan #"}, {field: "date", action: "rename", name: "Effective Date"}]);
  };

  const getHomePaymentsInfoAysnc = async () => {
    try {
      const response = FeatureFlags.IS_MOCK ? await getMockHomePaymentsInfolist() : await getHomePaymentsInfolist(props.proxyUser && props.proxyUser.id);
      if (response && response.ok) {
        props.setIsMessage(false);
        const homePaymentsInfolist = await response.json();
        const homePaymentsViews = [] as IHomePaymentsObj[];
        homePaymentsInfolist.forEach((homePaymentsInfolistItem) => {
          homePaymentsViews.push(homePaymentsInfolistItem);
        });
        
        setHomePaymentsInfoData(homePaymentsViews);
      }
      else {
        await handleErrorResponse(response, props.setIsMessage, props.setErrorResponse);
      }
    }
    catch (error) {
      handleError();
    }

    setIsLoading(false);
  };

    return (
      <BWHomeViewAllFrame 
        isGreaterThanTablet={props.isGreaterThanTablet}
        isSidebar={props.isSidebar}
        isMessage={props.isMessage}
        setIsMessage={props.setIsMessage}
        errorResponse={props.errorResponse}
        setErrorResponse={props.setErrorResponse}
        proxyUser={props.proxyUser}
        isLoading={isLoading}
        breadcrumbsCurrent="Payments"
        formattedDate={convertToTableFormat(homePaymentsInfoData)}
        getApiInfoAsync={getHomePaymentsInfoAysnc}
        infolistStyleSwitch={false}
        emptyState={{icon: "dollar sign", text: "You currently do not have any payment history"}}
        tableSortable={["Loan #", "Project", "Status", "Amount"]}
      />
  );
  };
  
export default BWHomePayments;